import * as React from "react";
import { useLocation } from "react-router-dom";

import { Box, Typography, Divider } from "@mui/material";

export default function Error() {
	const location = useLocation();

	const getErrorMessage = () => {
		if (location.search === "?client-not-found") {
			return "Client not found.";
		} else if (location.search === "?invalid-invite") {
			return "Invalid Invite Code.";
		}
		return "Something went wrong. Please try refreshing your screen, or contact your training company if issues continue.";
	};
	return (
		<React.Fragment>
			<Box
				sx={{
					bgcolor: "white",
					height: "100%",
					width: { xs: "100%", sm: "calc(100% - 4px)" },
					p: 3,
					overflow: "auto",
					borderRadius: "18px 18px 0px 0px",
				}}
			>
				<Typography
					variant="h3_bold"
					sx={{
						display: "flex",
						justifyContent: "center",
						mt: 1,
						color: "#06b6ad",
						textAlign: "center",
					}}
				>
					OOPS...
				</Typography>
				<Typography
					variant="h6"
					sx={{
						display: "flex",
						justifyContent: "center",
						mt: 1,
						color: "#06b6ad",
						textAlign: "center",
					}}
				>
					{getErrorMessage()}
				</Typography>
				<Divider sx={{ my: 3 }} />
				{/* <Typography
					variant="tlrg_footer"
					sx={{
						textAlign: "center",
						display: "flex",
						justifyContent: "center",
						mb: 5,
					}}
				>
					The Learning Resources Group
				</Typography> */}
			</Box>
		</React.Fragment>
	);
}
